import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const SupernovaFragAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  ctx.lineWidth = 3;
  for (let i = 0; i < 80; i++) {
    const a = Math.random() * Math.PI * 2;
    const d1Base = e.maxRadius + progress * 50;
    const d2Base = e.maxRadius + progress * 1000;
    const r1 = getRadiusAtAngle(a, e, d1Base);
    const r2 = getRadiusAtAngle(a, e, d2Base);
    ctx.beginPath(); ctx.moveTo(e.pos.x + Math.cos(a) * r1, e.pos.y + Math.sin(a) * r1);
    ctx.lineTo(e.pos.x + Math.cos(a) * r2, e.pos.y + Math.sin(a) * r2);
    ctx.stroke();
  }
};

registerBlastAnimation('SUPERNOVA_FRAG', SupernovaFragAnimation);
